import React from 'react'

function TenderTextLTD() {
  return (
    <embed src="\pdfs\EA3.3_ltd_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextLTD